import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpParams,HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';

@Injectable({providedIn: 'root'})
export class FileUploadService {
  private _httpClient = inject(HttpClient);
  private _cathyService = inject(CathyService);

  isUploading = signal<boolean>(false);
  uploadPercentage = signal<number>(0);
  uploadResponse = signal<any>(null);
  resetUploadForm = signal<boolean>(false);

  uploadFiles(endpoint: string, httpParams: HttpParams | null, filesFormParamKey: string, files: File[]): Observable<number> {
    if (files.length === 0) {
      throw new Error('Trying to upload without providing files.');
    }

    //I am letting the server handle the file size validation.
    /*const maxFileSize = 50 * 1024 * 1024; // 50MB
    for (const file of files) {
      if (file.size > maxFileSize) {
        this._cathyService.error(`File "${file.name}" is too large. Max size allowed is 50MB.`);
        throw new Error(`File "${file.name}" is too large. Max size allowed is 50MB.`);
      }
    }*/

    const formData = new FormData();
    for (const file of files) {
      formData.append(`${filesFormParamKey}[]`, file, file.name);
    }

    const options = {
      params: httpParams ?? new HttpParams(),
    };

    this.isUploading.set(true);

    return this._httpClient.post<HttpEvent<any>>(endpoint, formData, {
      ...options,
      reportProgress: true,   // Enables progress tracking
      observe: 'events',
    }).pipe(
      map(
        (uploadEvent:HttpEvent<any>) => {
          let percentage = 0;

          switch (uploadEvent.type) {

            case HttpEventType.UploadProgress:
              // console.log('UploadProgress', uploadEvent);
              if (uploadEvent.total) {
                percentage = Math.round((100 * uploadEvent.loaded) / uploadEvent.total);
              } else {
                percentage = 0;
              }
              break;

            case HttpEventType.Response:
              percentage = 100; // complete
              this.isUploading.set(false);
              // Check for 'success' field in the response body
              // eslint-disable-next-line no-case-declarations
              const response = (uploadEvent as HttpResponse<any>).body;

              this.uploadResponse.set(response)
              if (response && response.success === false) {

                this._cathyService.error(response.message);
                // Throw an error with the message from the response
                throw new Error(response.message || 'Upload failed');
              }
              break;

            default:
              percentage = 0;
              break;
          }

          this.uploadPercentage.set(percentage);
          return percentage;
      })
    )
  }

}


